import { render, staticRenderFns } from "./ClientProfileTabs.vue?vue&type=template&id=ad226ed8&scoped=true"
import script from "./ClientProfileTabs.vue?vue&type=script&lang=js"
export * from "./ClientProfileTabs.vue?vue&type=script&lang=js"
import style0 from "./ClientProfileTabs.vue?vue&type=style&index=0&id=ad226ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad226ed8",
  null
  
)

export default component.exports